import {Component} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import * as d3 from 'd3';
import {OauthService} from "../services/oauth.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APIURL} from "../services/url.config";
import {AlertService} from "../services/alert.service";

@Component({
    selector: 'client-dashboard',
    templateUrl: './client-dashboard.component.html',
    styleUrls: ['./dashboard-style.css']
})

export class ClientDashboardComponent{
    // possible sort selections
    typeSelector: UntypedFormGroup;
    types: any = [
        { itemId: "cvasc", item: "CAPD Client Version (Oldest to Newest)" },
        { itemId: "cvdes", item: "CAPD Client Version (Newest to Oldest)" },
        { itemId: "fdasc", item: "FD Version (Oldest to Newest)" },
        { itemId: "fddes", item: "FD Version (Newest to Oldest)" },
        { itemId: "servasc", item: "CAPD Server Version (Oldest to Newest)" },
        { itemId: "servdes", item: "CAPD Server Version (Newest to Oldest)"},
        { itemId: "timeasc", item: "Time Stamp (Oldest to Newest)"},
        { itemId: "timedes", item: "Time Stamp (Newest to Oldest)"}
    ]
    displayData: any;
    selectedPieSlice: boolean = false;
    selectedPieSliceVersion: any;

    constructor(private fb: UntypedFormBuilder,
                private auth: OauthService,
                private http: HttpClient,
                private alertService: AlertService) {selectOrder: new UntypedFormControl() }


    ngOnInit() {
        this.typeSelector = this.fb.group({
            category: [this.types],
            selectOrder: new UntypedFormControl()
        });
    }

    categoryOnChange(e){

        this.printSortedJSONData(e.target.value);
    }

    weeksOnChange(e) {
        this.updateWeeks(e.target.value);
    }

    monthsOnChange(e) {
        this.updateMonths(e.target.value);
    }

    //read in JSON
    printSortedJSONData(selectedValue) {
        this.selectedPieSlice = false;
        let print_limit: number = 0; // temp variable for counting
        document.getElementById('loader-data').style.display="flex";

        if(selectedValue == '0: cvasc' || selectedValue == '2: fdasc' || selectedValue == '4: servasc' || selectedValue == '6: timeasc') {
            if(selectedValue == '0: cvasc')  selectedValue = "EchoClientVersion"
            else if(selectedValue == '2: fdasc') selectedValue = "HostingApplicationVersion";
            else if(selectedValue == '4: servasc') selectedValue = "EchoServerVersion";
            else if(selectedValue == '6: timeasc') selectedValue = "EchoTimeStamp"

            this.auth.getToken().then(token => {
                const authorization = 'bearer ' + token;
                const options = {
                    headers: new HttpHeaders({ Authorization: authorization })
                };

                return this.http.get<string[]>(APIURL + 'api/dashboard/sorted_query_asc/' + selectedValue, options).toPromise().then(data => {

                // first check for null value
                if (selectedValue == 'EchoClientVersion' || selectedValue == 'HostingApplicationVersion' || selectedValue == 'EchoServerVersion') {
                    var newdata = data.sort(this.versionSortAsc(selectedValue));
                }
                else {
                    var newdata = data.sort(this.dateSortAsc())
                }
                print_limit = 0;
                for (let i = 0; i < newdata.length; i++) {
                    if(selectedValue == 'EchoClientVersion') {
                            //@ts-ignore
                            if (0 <= newdata[i].EchoClientVersion.charAt(0) && 9 >= newdata[i].EchoClientVersion.charAt(0)) {
                                this.printJSONData(newdata[i]);
                                print_limit++;
                            }
                            this.displayData = newdata;
                    }
                else if(selectedValue == 'HostingApplicationVersion') {
                    //@ts-ignore
                    if(0 <= newdata[i].HostingApplicationVersion.charAt(0) && 9 >= newdata[i].HostingApplicationVersion.charAt(0)) {
                        this.printJSONData(newdata[i]);
                        print_limit++;
                    }
                    this.displayData = newdata
                }
                else if(selectedValue == 'EchoServerVersion') {
                    //@ts-ignore
                    if(0 <= newdata[i].EchoServerVersion.charAt(0) && 9 >= newdata[i].EchoServerVersion.charAt(0)) {
                        this.printJSONData(newdata[i]);
                        print_limit++;
                    }
                    this.displayData = newdata
                }
                else if(selectedValue == 'EchoTimeStamp') {
                    this.printJSONData(newdata[i]);
                    print_limit++;
                }
                    this.displayData = newdata
                }
                document.getElementById('loader-data').style.display="none";

            })})
        }
        else if (selectedValue == '1: cvdes' || selectedValue == '3: fddes' || selectedValue == '5: servdes' || selectedValue == '7: timedes') {
            if(selectedValue == '1: cvdes') selectedValue = "EchoClientVersion";
            else if(selectedValue == '3: fddes') selectedValue = "HostingApplicationVersion";
            else if(selectedValue == '5: servdes') selectedValue = "EchoServerVersion";
            else if (selectedValue == '7: timedes') selectedValue = "EchoTimeStamp";

            this.auth.getToken().then(token => {
                const authorization = 'bearer ' + token;
                const options = {
                    headers: new HttpHeaders({ Authorization: authorization })
                };

                return this.http.get<string[]>(APIURL + 'api/dashboard/sorted_query_des/' + selectedValue, options).toPromise().then(data => {
                if (selectedValue == 'EchoClientVersion' || selectedValue == 'HostingApplicationVersion' || selectedValue == 'EchoServerVersion') {
                    var newdata = data.sort(this.versionSortDes(selectedValue));
                }
                else {
                    var newdata = data.sort(this.dateSortDes())
                }
                print_limit = 0;
                for (let i = 0; i < newdata.length; i++) {
                    if(selectedValue == 'EchoClientVersion') {
                        //@ts-ignore
                        if (0 <= newdata[i].EchoClientVersion.charAt(0) && 9 >= newdata[i].EchoClientVersion.charAt(0)) {
                            this.printJSONData(newdata[i]);
                            print_limit++;
                        }
                        this.displayData = newdata
                    }
                    else if(selectedValue == 'HostingApplicationVersion') {
                        //@ts-ignore
                        if(0 <= newdata[i].HostingApplicationVersion.charAt(0) && 9 >= newdata[i].HostingApplicationVersion.charAt(0)) {
                            this.printJSONData(newdata[i]);
                            print_limit++;
                        }
                        this.displayData = newdata
                    }
                    else if(selectedValue == 'EchoServerVersion') {
                        //@ts-ignore
                        if(0 <= newdata[i].EchoServerVersion.charAt(0) && 9 >= newdata[i].EchoServerVersion.charAt(0)) {
                            this.printJSONData(newdata[i]);
                            print_limit++;
                        }
                        this.displayData = newdata
                    }
                    else if(selectedValue == 'EchoTimeStamp') {
                        this.printJSONData(newdata[i]);
                        print_limit++;
                    }
                    this.displayData = newdata
                }
                document.getElementById('loader-data').style.display="none";

            })});
        }
    }

    printJSONData(data) {
        let account: String = this.reformatAccount(data.Account);
        let reformatted_date: String = this.reformatDate(data.EchoTimeStamp);

        data.Account = account;
        data.EchoTimeStamp = reformatted_date;
    }

    reformatAccount (account) {
        // this slices off text from the account name that would be the same for all accounts
        if(account != null) {
            if (account.charAt(0) == "c")
                account = account.slice(0, account.length - 62);
            return account;
        }
    }

    reformatDate(rawDate) {
        let date = new Date(rawDate);
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let year = date.getFullYear();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let minute_string: String;


        //am or pm check
        let amorpm;
        if (hour < 12)
            amorpm = "am";
        else if (hour >= 12) {
            amorpm = "pm";
            if (hour != 12)
                hour = hour - 12;
        }

        // add leading 0 if less than 10 minutes
        if (minute < 10) {
            minute_string = "0" + minute.toString();
        } else minute_string = minute.toString();

        return month + "/" + day + "/" + year + " " + hour + ":" + minute_string + " " + amorpm;
    }

    // function for generating pie chart
    draw(chartType, data) {

        // variables for pie chart sizing
        let width = 800,
            height = 400,
            radius = Math.min(width, height)/2.5;

        let arc: any = d3.arc()
            .outerRadius(radius - 10)
            .innerRadius(0);

        let outerArc: any = d3.arc()
            .innerRadius(radius*0.9)
            .outerRadius(radius*0.9);

        let labelArc: any = d3.arc()
            .outerRadius(radius * 2.1)
            .innerRadius(0);

        //read in the json data from api
        // d3.json("/api/date_query", function(data) {
        document.getElementById('loader-chart').style.display="flex";

        // check if data has been populated
        if(data.length == 0) {
            this.alertService.showAlert("No data in selected date range!");
            $("#type-button-container").show();
            $("#radio-buttons-container").show();
            $("chartdiv").hide();
            document.getElementById('loader-chart').style.display="none";
            return -1;
        }


        let counts = [];                    //  save count of each version
        let countArrayNumbers = [];         // save counts as an array (otherwise appears as object which cannot be read by d3)
        let arrayLabels = [];               // array to store the version number (to be used to label pie chart)
        let countArray: any;
        // count number of times each version appears, save to counts variable
        for (let i = 0; i < data.length; i++) {
            if(data[i] != undefined)
                counts[data[i]] = 1 + (counts[data[i]] || 0);
        }
        // save count to array, reformat to json
        countArray = Object.entries(counts);
        countArray = JSON.stringify(countArray);
        countArray = JSON.parse(countArray);

        // save count numbers and version numbers as separate variables
        for (let i = 0; i < countArray.length; i++) {
            countArrayNumbers[i] = parseInt(countArray[i][1]);
            arrayLabels[i] = countArray[i][0];
        }

        let sum = countArrayNumbers.reduce((x, y) => x + y);

        // add percentages to countArray
        for (let i = 0; i < countArray.length; i++) {
            countArray[i][2] = (countArrayNumbers[i] / sum) * 100;
            countArray[i][2] = countArray[i][2].toFixed(2);
        }

        document.getElementById('loader-chart').style.display="none";
        $("#type-button-container").show();
        $("#radio-buttons-container").show();


        //.call(d3.zoom().on("zoom", function() {svg.attr("transform", d3.event.transform)}))
        //d3 svg sizing
        let svg = d3.select("#chartdiv").append('svg')
            .attr("width", width)
            .attr("height", height)
            .attr("visibility", "visible")
            .append('g')
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        d3.zoom().scaleExtent([100, 100])
        //generate pie chart
        let pie = d3.pie()
            .sort(null)
            .value(function(d: any) { return d; });



        let g = svg.selectAll(".arc")
            .data(pie(countArrayNumbers))
            .enter().append("g")
            .attr("class", "arc");

        g.append("path")
            .attr("d", arc)
            .style("fill", function(d) { return this.generateColor(); }.bind(this));

        //text labels
        svg.append("g")
            .attr("class", "labels");
        svg.append("g")
            .attr("class", "lines");

        let key = function(d) { return arrayLabels[d.index]; };

        let text = svg.select(".labels").selectAll("text")
            .data(pie(countArrayNumbers), key);

        function midAngle(d) {
            return d.startAngle + (d.endAngle - d.startAngle) / 2;
        }
        let count = 0;
        text.enter()
            .append("text")

            .attr("text-anchor", function(d) {
                //anchor text based on side of piechart
                return (d.endAngle + d.startAngle)/2 > Math.PI ? "end" : "start";
            })
            .attr("transform", function(d, i) {
                let pos = outerArc.centroid(d);
                pos[0] = radius * (midAngle(d) < Math.PI ? 1.1 : -1.1);

                return "translate(" + pos + ")";
            })
            .attr("style", "font-size: 20; font-weight: 300; margin: 10px;")
            .text(function(d) {
                // if statement -> do not show labels of small slices
                if(d.endAngle - d.startAngle<10*Math.PI/180){return ""}
                return "Version: " + arrayLabels[d.index];
            });

        text.exit().remove();

        // polylines from chart to label
        let polyline = g.selectAll("polyline")
            .data(pie(countArrayNumbers), function(d: any) {
                return arrayLabels[d.index];
            });
        polyline.enter()
            .append("polyline")
            // @ts-ignore
            .attr("points", function(d: any) {
                if(d.endAngle - d.startAngle>10*Math.PI/180) {
                    let pos = outerArc.centroid(d);
                    pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1.1 : -1.1);
                    let o = outerArc.centroid(d);
                    return [arc.centroid(d), [o[0], pos[1]], pos]; // typescript doesn't like this line
                }
            })
            .style("fill", "none")
            .attr("stroke", "grey")
            .style("stroke-width", "1px");

        g.on('mouseover', hoveron)
            .on('mouseout', hoveroff);

        function hoveron(d) {
            d3.select(this).transition()
                .duration(50)
                .attr('opacity', '.75');
        }

        //change opacity on mouse out
        function hoveroff(d) {
            d3.select(this).transition()
                .duration(50)
                .attr('opacity', '1');
        }

        g.on('click', (function clicked(d) {
            let onScreen = 0;
            let months = 0;
            let localversion =  arrayLabels[d.path[1].__data__.index];

            // get whether we should check echoclientversion or hostingapplicationversion
            let dataType: any = document.querySelector('input[name="version-type"]:checked');
            dataType = dataType.id

            // get value for date calculation (weeks or months bacK)
            if (document.getElementById('weeks-container').querySelector('input[name="date-range"]:checked')) {
                months = document.getElementById('weeks-container').querySelector('input[name="date-range"]:checked')["value"];
            }else if (document.getElementById('months-container').querySelector('input[name="date-range"]:checked')) {
                months = document.getElementById('months-container').querySelector('input[name="date-range"]:checked')["value"];
            }
            //
            $("#sortselection").val("none");
            let versionSplit = localversion.split('.')
            let buildNum = versionSplit[3]

            // http client is not reachable within these multiple functions, moved to its own function w/ token request
            this.requestDataOnClick(months, dataType, buildNum, localversion).then(data => {
                this.selectedPieSlice = true;
                this.selectedPieSliceVersion = localversion;

                    // new function for retrieving data on click here
                    for (let i = 0; i < data.length; i++)
                    {
                        //print records matching selected slice
                        // limit number of records on screen
                        if((data[i][chartType] == arrayLabels[d.path[1].__data__.index]) && (onScreen < 200)) {
                            onScreen++;
                            this.printJSONData(data[i]);
                        }
                        this.displayData = data;
                    }
                })
        }).bind(this));

        countArray.sort(function(a, b) {return b[2] - a[2]});

        let table = d3.select("#chartdiv").append("table");
        let header = table.append("thead").append("tr");
        header.selectAll("th")
            .data(["Version Number", "Version Count", "Percentage"])
            .enter()
            .append("th")
            .text(function(d) { return d; });
        let tablebody = table.append("tbody");
        let rows = tablebody
            .selectAll("tr")
            .data(countArray)
            .enter()
            .append("tr");
        let cells = rows.selectAll("td")
            .data(function(d: any) {
                return d;
            })
            .enter()
            .append("td")
            .text(function(d: any) {
                return d;
            });
        d3.select("#chartdiv").selectAll("table").style("margin-right", "auto")
            .style("margin-left", "auto").style("border", "1px solid black").style("border-collapse", "collapse")
            .style("background-color", "#CCCCCC").style("text-align", "center");
        d3.select("#chartdiv").selectAll("td").style("border", "1px solid black")
            .style("padding", "5px").style("border-collapse", "collapse");
        d3.select("#chartdiv").selectAll("th").style("border", "1px solid black")
            .style("padding", "5px").style("border-collapse", "collapse");
    }

    // function to generate random color
    //   used to fill pie chart slices
    generateColor() {
        let letters = '0123456789ABCDEF';
        let color = "#";
        for(let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;

    }

    updateMonths(months) {
        this.hideOptions();

        document.getElementById('loader-chart').style.display="flex";

        //get which version is checked
        let dataType: any = document.querySelector('input[name="version-type"]:checked');
        dataType = dataType.id;

        this.auth.getToken().then(token => {
            const authorization = 'bearer ' + token;
            const options = {
                headers: new HttpHeaders({Authorization: authorization})
            };

            return this.http.get<string[]>(APIURL + 'api/dashboard/months_query?months=' + months + '&dataType=' + dataType, options).toPromise().then(data => {
                this.draw(dataType, data);
            })
        })

    }

    updateWeeks(weeks) {
        this.hideOptions();

        document.getElementById('loader-chart').style.display="flex";

        //get which version is checked
        let dataType: any = document.querySelector('input[name="version-type"]:checked');
        dataType = dataType.id;

        this.auth.getToken().then(token => {
            const authorization = 'bearer ' + token;
            const options = {
                headers: new HttpHeaders({Authorization: authorization})
            };

            return this.http.get<string[]>(APIURL + 'api/dashboard/weeks_query?weeks=' + weeks + '&dataType=' + dataType, options).toPromise().then(data => {
                this.draw(dataType, data);
            })
        })
    }

    updateVersionType(type) {

        let val = 0

        if (document.getElementById('weeks-container').querySelector('input[name="date-range"]:checked')) {
            val = document.getElementById('weeks-container').querySelector('input[name="date-range"]:checked')["value"];
            this.updateWeeks(val);
        }else if (document.getElementById('months-container').querySelector('input[name="date-range"]:checked')) {
            val = document.getElementById('months-container').querySelector('input[name="date-range"]:checked')["value"];
            this.updateMonths(val);
        }
    }

    pieVisibility() {
        let pie = d3.select("#chartdiv").select("svg");
        if(pie.attr("visibility") == "visible") {
            pie.attr("visibility", "hidden"); //hide pie chart
            document.getElementById('chartdiv').style.display = "none";
            document.getElementById('pie-selectors-container').style.display = "none";
            document.getElementById('btn-pie').firstChild["data"] ="Show Pie Chart";
        } else {
            document.getElementById('chartdiv').style.display = "block";
            document.getElementById('pie-selectors-container').style.display = "block";
            pie.attr("visibility", "visible");
            document.getElementById('btn-pie').firstChild["data"] ="Hide Pie Chart";
        }
    }

    hideOptions() {
        d3.select("#chartdiv").selectAll("svg").remove();
        d3.select("#chartdiv").selectAll("table").remove();
        d3.select("#chartdiv").selectAll("th").remove();
        d3.select("#chartdiv").selectAll("tr").remove();
        d3.select("#chartdiv").selectAll("td").remove();
        $("#type-button-container").hide();
        $("#radio-buttons-container").hide();
    }

    increaseVersion(a, type) {

        if(a[type] == undefined) return 0;
        a[type] = a[type].split('.').map(n=>+n+1000000).join('.');
    }

    decreaseVersion(a, type) {

        if(a[type] == undefined) return 0;
        a[type] = a[type].split('.').map(n=>+n-1000000).join('.');
    }

    versionSortAsc(type) {
        var typeLower = type.charAt(0).toLowerCase() + type.substring(1)
        return function(a,b) {
            if(a[typeLower] == undefined || a[typeLower].charAt(0) == '#') return 0;
            else if(b[typeLower] == undefined || b[typeLower].charAt(0) == '#') return 0;
            else {
                this.increaseVersion(a, typeLower)
                this.increaseVersion(b, typeLower)
            }


            if(a[typeLower] > b[typeLower]) {
                this.decreaseVersion(a, typeLower)
                this.decreaseVersion(b, typeLower)
                return 1;
            }
            else if (a[typeLower] < b[typeLower]) {
                this.decreaseVersion(a, typeLower)
                this.decreaseVersion(b, typeLower)
                return -1;
            }
            else {
                this.decreaseVersion(a, typeLower)
                this.decreaseVersion(b, typeLower)
            }

            return 0;
        }.bind(this)

    }

    versionSortDes(type) {
        var typeLower = type.charAt(0).toLowerCase() + type.substring(1)
        return function(a,b) {
            if(a[typeLower] == undefined || a[typeLower].charAt(0)) return 0;
            if(b[typeLower] == undefined || b[typeLower].charAt(0)) return 0;
            else {
                this.increaseVersion(a, typeLower)
                this.increaseVersion(b, typeLower)
            }

            if(a[typeLower] < b[typeLower]) {
                this.decreaseVersion(a, typeLower)
                this.decreaseVersion(b, typeLower)
                return 1;
            }
            else if (a[typeLower] > b[typeLower]) {
                this.decreaseVersion(a, typeLower)
                this.decreaseVersion(b, typeLower)
                return -1;
            }
            else {
                this.decreaseVersion(a, typeLower)
                this.decreaseVersion(b, typeLower)
            }

            return 0;
        }.bind(this)
    }

    dateSortAsc() {
        return function(a, b) {
            if(a.EchoTimeStamp > b.EchoTimeStamp)
                return 1;
            else if (a.EchoTimeStamp < b.EchoTimeStamp)
                return -1;
            return 0;
        }
    }

    dateSortDes() {
        return function(a, b) {
            if(a.EchoTimeStamp < b.EchoTimeStamp)
                return 1;
            else if (a.EchoTimeStamp > b.EchoTimeStamp)
                return -1;
            return 0;
        }
    }

    requestDataOnClick(months, dataType, buildNum, localversion) {
        return this.auth.getToken().then(token => {
            const authorization = 'bearer ' + token;
            const options = {
                headers: new HttpHeaders({Authorization: authorization})
            }

            return this.http.get(APIURL + 'api/dashboard/months_query/' + localversion + '?months=' + months + '&dataType=' + dataType + '&buildNum=' + buildNum, options).toPromise()
        })
    }

    clearData() {
        this.selectedPieSlice = false;
        this.selectedPieSliceVersion = '';
        this.displayData = [];
    }
}
